import React from 'react';
import './ErrorMessage.scss';

const ErrorMessage = ({ message }) => {
    if (!message) {
        return null;
    }
    return (
        <div className="error-message text-danger">
            <p>{message}</p>
        </div>
    );
};

export default ErrorMessage;
